import {Helmet} from 'react-helmet'
import {Text} from '@/components/ui/text/Text'
import FondazioneLogo from '@/assets/images/logo-fondazione-uildm-lazio.jpg'
import IsoCertificationLogo from '@/assets/images/logo-certificazione-iso-9001.jpg'
import {
    StyledCertificationLogo,
    StyledDpoTable,
    StyledFoundationLogo,
    StyledLogosRow,
    StyledPrivacyPolicyContent,
    StyledPrivacyPolicyHeader,
    StyledPrivacyPolicyPage,
    StyledPrivacyPolicySection,
    StyledTableScroll
} from './style'

/**
 * Public page reproducing the foundation's "Informativa sul trattamento dei
 * dati personali" (GDPR), previously only available as a PDF. The text is a
 * verbatim transcription of that document, so it must not be reworded
 * without legal sign-off.
 */
export const PrivacyPolicy = () => {
    return (
        <StyledPrivacyPolicyPage>
            <Helmet title="Informativa sul trattamento dei dati personali" />
            <StyledPrivacyPolicyContent>
                <StyledPrivacyPolicyHeader>
                    <StyledLogosRow>
                        <StyledFoundationLogo src={FondazioneLogo} alt="Fondazione UILDM Lazio" />
                        <StyledCertificationLogo
                            src={IsoCertificationLogo}
                            alt="Certificazione Dasa-Rägister UNI EN ISO 9001:2015 IQ-0120-04"
                        />
                    </StyledLogosRow>
                    <Text render="h1" size="displayXs" weight="600" palette="neutral" shade="950">
                        Informativa sul trattamento dei dati personali
                    </Text>
                    <Text size="textSm" palette="neutral" shade="600">
                        Regolamento (UE) 2016/679 del Parlamento Europeo e del Consiglio del 27 aprile 2016
                    </Text>
                    <Text size="textSm" palette="neutral" shade="600">
                        Informativa Interessati – Corsi di formazione
                    </Text>
                    <Text size="textSm" palette="neutral" shade="500">
                        FONDAZIONE UILDM LAZIO onlus – 00167 Roma, Via Prospero Santacroce, 5 – tel. +39.06.6604881 –
                        fax +39.06.6638149 – Cod. Fisc. e Part. IVA 13881211000
                    </Text>
                </StyledPrivacyPolicyHeader>

                <Text size="textSm" palette="neutral" shade="700">
                    Ai sensi e per gli effetti degli articoli 13 e 14 del Regolamento generale sulla protezione dei dati
                    (Regolamento dell’Unione Europea 2016/679 del Parlamento Europeo e del Consiglio del 27 aprile 2016
                    relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali,
                    nonché alla libera circolazione di tali dati, d’ora in poi Regolamento), informiamo che la
                    FONDAZIONE UILDM LAZIO onlus, Via Prospero Santacroce, 5, 00167 Roma (RM), tratta i dati personali
                    forniti e liberamente comunicati dall&apos;interessato (soggetto partecipante ai corsi di
                    formazione). La FONDAZIONE UILDM LAZIO onlus garantisce che il trattamento dei dati personali si
                    svolge nel rispetto dei diritti e delle libertà fondamentali, nonché della dignità, con particolare
                    riferimento alla riservatezza, all&apos;identità personale e al diritto alla protezione dei dati
                    personali dell&apos;interessato. I dati personali dell’interessato trattati da FONDAZIONE UILDM
                    LAZIO onlus sono stati ottenuti anche da soggetti diversi dall’interessato.
                </Text>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        1. Titolare del trattamento dei dati personali (Art. 13 paragrafo 1 lettera a - Art. 14
                        paragrafo 1 lettera a del Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        Il titolare del trattamento dei dati personali è la FONDAZIONE UILDM LAZIO onlus. Alla data
                        odierna ogni informazione inerente il titolare, congiuntamente all&apos;elenco aggiornato dei
                        responsabili e degli amministratori di sistema designati, è reperibile presso la sede della
                        FONDAZIONE UILDM LAZIO onlus in Via Prospero Santacroce, 5, 00167 Roma (RM).
                    </Text>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        2. Finalità del trattamento dei dati personali (Art. 13 paragrafo 1 lettera c - Art. 14
                        paragrafo 1 lettera c del Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        Tutti i dati personali comunicati dall&apos;interessato (dati anagrafici, recapiti tradizionali
                        e digitali quali l’indirizzo email, professione, estremi di un documento d’identità, dati
                        bancari, etc.) sono trattati per la gestione del servizio dei corsi di formazione organizzati ed
                        erogati dal Titolare. Nello specifico i dati personali dell’interessato sono trattati per le
                        seguenti finalità:
                    </Text>
                    <ul>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                inserimento nei database informatici della Fondazione;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                compilazione della scheda di registrazione e di iscrizione ai corsi presente sul sito
                                internet della Fondazione;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                organizzazione, gestione ed erogazione di corsi di formazione, anche ECM;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                gestione procedure per riconoscimento crediti ECM;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                adempiere ad obblighi contrattuali e di natura contabile e fiscale (es.: emissione
                                fatture);
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                rilasciare un attestato di partecipazione;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                gestione delle comunicazioni inerenti allo svolgimento e alla programmazione del corso
                                di formazione;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                assolvere a specifiche richieste dell’interessato.
                            </Text>
                        </li>
                    </ul>
                    <Text size="textSm" palette="neutral" shade="700">
                        La liceità del trattamento dei dati personali deriva dai seguenti presupposti di liceità:
                    </Text>
                    <ul>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                esecuzione di un contratto di cui l’interessato è parte o dall&apos;esecuzione di misure
                                precontrattuali adottate su richiesta dello stesso (art. 6 comma 1, lettera b) del
                                Regolamento);
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                rispondere ad un obbligo di legge (Art. 6 comma 1, lettera c) Regolamento).
                            </Text>
                        </li>
                    </ul>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        3. Le modalità del trattamento dei dati personali
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        Il trattamento dei dati personali avviene presso gli uffici della FONDAZIONE UILDM LAZIO onlus,
                        o qualora fosse necessario, presso i soggetti indicati al paragrafo 5, utilizzando sia supporti
                        cartacei che informatici, anche attraverso strumenti automatizzati atti a memorizzare, gestire e
                        trasmettere i dati stessi, con l’osservanza di ogni misura cautelativa, che ne garantisca la
                        sicurezza e la riservatezza. Il trattamento si svilupperà in modo da ridurre al minimo il
                        rischio di distruzione o perdita, di accesso non autorizzato, di trattamento non conforme alle
                        finalità della raccolta dei dati stessi. I dati personali sono trattati nel rispetto del
                        principio di minimizzazione, ai sensi degli articoli 5 paragrafo 1 lettera c e 25 paragrafo 2
                        del Regolamento. Quindi sono trattati in modo lecito e secondo correttezza, sono raccolti per
                        scopi determinati espliciti e legittimi, sono esatti e se necessario aggiornati, sono
                        pertinenti, completi e non eccedenti rispetto alle finalità del trattamento.
                    </Text>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        4. Natura della raccolta e conseguenze di un eventuale mancato conferimento dei dati personali
                        (Art. 13 paragrafo 2 lettera e del Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        Il conferimento dei dati personali è obbligatorio per potere fruire e partecipare ai corsi di
                        formazione. Il loro mancato conferimento comporta la mancata erogazione del servizio richiesto
                        e/o del suo corretto svolgimento (possibilità di iscriversi al corso e/o di fruire dello
                        stesso).
                    </Text>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        5. Comunicazione e diffusione dei dati personali (Art. 13 paragrafo 1 lettera e - Art. 14
                        paragrafo 1 lettera e del Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        I dati personali, qualora fosse necessario, possono essere comunicati (con tale termine
                        intendendosi il darne conoscenza ad uno o più soggetti determinati):
                    </Text>
                    <ul>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                ai soggetti la cui facoltà di accesso ai dati è riconosciuta da disposizioni di legge
                                nazionali e dell’Unione Europea;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                ai soggetti ai quali la comunicazione dei dati personali risulti necessaria o comunque
                                funzionale alla gestione dell’erogazione del corso di formazione (società che gestisce
                                tecnologicamente il sito internet della Fondazione, Provider ECM) nei modi e per le
                                finalità sopra illustrate.
                            </Text>
                        </li>
                    </ul>
                    <Text size="textSm" palette="neutral" shade="700">
                        I dati personali non vengono in alcun caso diffusi, con tale termine intendendosi il darne
                        conoscenza in qualunque modo ad una pluralità di soggetti indeterminati.
                    </Text>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        6. Criteri utilizzati al fine di determinare il periodo di conservazione dei dati personali
                        (Art. 13 paragrafo 2 lettera a - Art. 14 paragrafo 2 lettera a del Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        I dati personali oggetto del trattamento utilizzati per l’iscrizione, l’organizzazione e
                        l’erogazione dei corsi di formazione nonché per le ulteriori finalità indicate al precedente
                        punto 2, saranno conservati per il periodo necessario a rispettare i termini di conservazione
                        stabiliti dalla legge e comunque non superiori a quelli necessari per la gestione delle
                        obbligazioni contrattuali e per la gestione dei possibili ricorsi/contenziosi.
                    </Text>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        7. Diritti dell’interessato (Art. 13 paragrafo 2 lettera b - Art. 14 paragrafo 2 lettera c del
                        Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        Si comunica che, in qualsiasi momento, l’interessato può esercitare i seguenti diritti:
                    </Text>
                    <ul>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                diritto di chiedere al Titolare del trattamento, ex Art. 15 Reg. 679/2016, di poter
                                accedere ai propri dati personali;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                Diritto di chiedere al Titolare del trattamento, ex Art. 16 Reg. 679/2016, di poter
                                rettificare i propri dati personali, ove quest’ultimo non contrasti con la normativa
                                vigente sulla conservazione dei dati stessi e con la necessità di tutelare in caso di
                                contenzioso giudiziario i professionisti sanitari che li hanno trattati;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                Diritto di chiedere al Titolare del trattamento, ex Art. 17 Reg. 679/2016, di poter
                                cancellare i propri dati personali, ove quest’ultimo non contrasti con la normativa
                                vigente sulla conservazione dei dati stessi e con la necessità di tutelare in caso di
                                contenzioso giudiziario i professionisti sanitari che li hanno trattati;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                Diritto di chiedere al Titolare del trattamento, ex Art. 18 Reg. 679/2016, di poter
                                limitare il trattamento dei propri dati personali;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                Diritto di opporsi al trattamento, ex Art. 21 Reg. 679/2016;
                            </Text>
                        </li>
                        <li>
                            <Text render="span" size="textSm" palette="neutral" shade="700">
                                Diritto di chiedere al Titolare del trattamento, solamente nei casi previsti all’art. 20
                                del reg. 679/2016, che venga compiuta la trasmissione dei propri dati personali ad altro
                                operatore sanitario in formato leggibile.
                            </Text>
                        </li>
                    </ul>
                    <Text size="textSm" palette="neutral" shade="700">
                        L’interessato può esercitare i diritti di cui sopra con richiesta rivolta senza formalità al
                        titolare del trattamento dei dati personali mediante consegna a mano, posta tradizionale,
                        lettera raccomandata, fax o tramite posta elettronica al seguente indirizzo{' '}
                        <a href="mailto:privacy@fondazioneuildmlazio.org">privacy@fondazioneuildmlazio.org</a>. Per
                        facilitare l’esercizio di tali diritti, l&apos;Autorità Garante per la protezione dei dati
                        personali italiana ha predisposto uno specifico modulo scaricabile dal sito{' '}
                        <a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer">
                            www.garanteprivacy.it
                        </a>
                    </Text>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        8. Diritto di presentare reclamo (Art. 13 paragrafo 2 lettera d - Art. 14 paragrafo 2 lettera e
                        del Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        Si rende noto all&apos;interessato che ha il diritto di proporre reclamo ad una autorità di
                        controllo (in particolar modo all&apos;Autorità Garante per la protezione dei dati personali
                        italiana).
                    </Text>
                </StyledPrivacyPolicySection>

                <StyledPrivacyPolicySection>
                    <Text render="h2" size="textLg" weight="600" palette="neutral" shade="950">
                        9. Data Protection Officer (DPO) (Art. 13 paragrafo 1 lettera b del Regolamento)
                    </Text>
                    <Text size="textSm" palette="neutral" shade="700">
                        Il Data Protection Officer individuato da FONDAZIONE UILDM LAZIO onlus è il seguente soggetto:
                    </Text>
                    <StyledTableScroll>
                        <StyledDpoTable>
                            <thead>
                                <tr>
                                    <th>DPO</th>
                                    <th>P.IVA</th>
                                    <th>Via/Piazza</th>
                                    <th>CAP</th>
                                    <th>Comune</th>
                                    <th>Nominativo del DPO</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>LTA S.r.l.</td>
                                    <td>14243311009</td>
                                    <td>Via della Conciliazione, 10</td>
                                    <td>00193</td>
                                    <td>Roma</td>
                                    <td>Fiorenzo Rossi</td>
                                </tr>
                            </tbody>
                        </StyledDpoTable>
                    </StyledTableScroll>
                    <Text size="textSm" palette="neutral" shade="700">
                        Il Data Protection Officer è reperibile presso la sede della FONDAZIONE UILDM LAZIO onlus, Via
                        Prospero Santacroce, 5, 00167 Roma (RM). In caso di istanze/comunicazioni scritte da inviarsi in
                        modalità digitale il Data Protection Officer può essere contattato utilizzando i recapiti
                        istituzionali della Fondazione (
                        <a href="mailto:privacy@fondazioneuildmlazio.org">privacy@fondazioneuildmlazio.org</a>) indicati
                        sul sito web dell&apos;Ente.
                    </Text>
                </StyledPrivacyPolicySection>
            </StyledPrivacyPolicyContent>
        </StyledPrivacyPolicyPage>
    )
}

PrivacyPolicy.displayName = 'PrivacyPolicy'
